export default "__VITE_ASSET__D2g$BWjn__"